import { seesMoney } from '@epc/contracts';
import { useQuery } from '@tanstack/react-query';
import { useSearch } from '@tanstack/react-router';
import { useState } from 'react';
import { useCrumbs } from '../../layout/crumbs';
import { projectQuery } from '../../lib/projects';
import { useMe } from '../../lib/session';
import { EmptyState, ErrorBox, Spinner } from '../../ui/feedback';
import { Field, Select } from '../../ui/form';
import { Page, PageHeader } from '../../ui/layout';
import { StatementTable } from './EstimatePage';
import { projectResourcesQuery } from './lib';

/** Ресурсная ведомость по проекту или объекту (СМ-15): материалы, оборудование, труд, машины — для бюджета, графика и закупок */
export function ResourcesPage() {
  const me = useMe();
  const search = useSearch({ strict: false }) as { projectId?: string };
  const projectId = search.projectId ?? '';
  const [objectId, setObjectId] = useState('');
  const project = useQuery({ ...projectQuery(projectId), enabled: Boolean(projectId) });
  const q = useQuery({
    ...projectResourcesQuery(projectId, objectId || undefined),
    enabled: Boolean(projectId),
  });
  const money = seesMoney(me.access, 'acts_invoices');
  useCrumbs(
    project.data
      ? [
          { label: project.data.code, to: `/estimates?projectId=${projectId}`, title: 'Сметы проекта' },
          { label: 'Ресурсная ведомость' },
        ]
      : projectId
        ? null
        : [{ label: 'Ресурсная ведомость' }],
    project.error,
  );

  if (!projectId)
    return (
      <Page>
        <EmptyState title="Проект не указан">Откройте ресурсную ведомость из списка смет проекта.</EmptyState>
      </Page>
    );
  return (
    <Page>
      <PageHeader
        title="Ресурсная ведомость"
        subtitle={
          project.data
            ? `${project.data.code} — ${project.data.name}: по текущим версиям локальных смет`
            : undefined
        }
      >
        {project.data?.objects.length ? (
          <Field label="Объект" className="mt-3 max-w-md">
            <Select value={objectId} onChange={(e) => setObjectId(e.target.value)}>
              <option value="">Весь проект</option>
              {project.data.objects.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.code ? `${o.code} — ` : ''}
                  {o.name}
                </option>
              ))}
            </Select>
          </Field>
        ) : null}
      </PageHeader>
      {q.isPending ? (
        <Spinner />
      ) : q.isError ? (
        <ErrorBox error={q.error} />
      ) : q.data.rows.length ? (
        <StatementTable
          st={q.data}
          money={money}
          exportHref={`/api/v1/estimates/resources/export?projectId=${projectId}${objectId ? `&objectId=${objectId}` : ''}`}
        />
      ) : (
        <EmptyState title="Ресурсов нет">В проекте ещё нет смет с позициями.</EmptyState>
      )}
    </Page>
  );
}
